import { Pipe, PipeTransform } from '@angular/core';
import DOMPurify from 'dompurify';

@Pipe({
  name: 'sanitizeHtml',
  standalone: true,
})
export class SanitizeHtmlPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) {
      return value;
    }
    return DOMPurify.sanitize(value, {
      ALLOWED_TAGS: ['b', 'strong', 'br', 'span', 'p'],
      ALLOWED_ATTR: ['class'],
    });
  }
}
